import { query, collection, orderBy, onSnapshot, addDoc, setDoc, doc, deleteDoc, getDocs, getDoc } from "firebase/firestore";
import { getCompanyId, db, sendError, getCurrentUserUID } from "./firebase";

const listeners: CallableFunction[] = [];
var snapshotListener: Function | null = null;
var lastSnapshotList: string[] | undefined = undefined;
var registered = false;



async function registerWorkspaceSnapshotListener() {
    if (registered) {
        return;
    }
    registered = true;
    const q = query(collection(db, 'companies'));
    const queryCompanies = await getDocs(q);
    const docs = queryCompanies.docs;
    lastSnapshotList = [];
    for (var i = 0; i < docs.length; i++) {
        const company = docs[i];
        const docRef = doc(db, "companies", company.id, 'users', getCurrentUserUID() + "");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            lastSnapshotList.push(company.id)
        }
    }
    lastSnapshotList = lastSnapshotList.sort((a: any, b: any) => {
        return a.localeCompare(b);
    })

    listeners.forEach(callback => {
        callback(lastSnapshotList);
    });

}

export function unregisterWorkspaceSnapshotListener(){
    lastSnapshotList = [];
    registered = false;
}

export async function addWorkspaceListener(callback: CallableFunction) {
    registerWorkspaceSnapshotListener();
    listeners.push(callback);
    if (lastSnapshotList !== undefined) {
        callback(lastSnapshotList);
    }
}

export function getWorkspaces() {
    return lastSnapshotList;
}
